import { traverse } from '@atlaskit/adf-utils/traverse/main';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

const SLACK_LINK_REGEX =
	/^https?:\/\/[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.slack\.com\/archives\/([A-Z0-9]+)(?:\/p\d+)?(?:\?.*)?$/i;
const MAILTO_REGEX = /^mailto:/i;
const MAILTO_EXTRACT_REGEX = /^mailto:([^?]+)(?:\?.*)?$/i;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

export const isSlackLink = (url?: string): url is string => {
	if (!url) return false;
	return SLACK_LINK_REGEX.test(url);
};

export const getChannelIdFromSlackLink = (link: string): string => {
	const match = link.match(SLACK_LINK_REGEX);
	return match ? match[1] : '';
};

export const isMailtoLink = (url?: string): url is string => {
	if (!url) return false;
	return MAILTO_REGEX.test(url);
};

export const getEmailsFromMailtoLink = (url?: string): string[] => {
	if (!url) return [];
	const match = url.match(MAILTO_EXTRACT_REGEX);
	if (!match) return [];
	return match[1].split(',').flatMap((email) => {
		const decoded = decodeURIComponent(email).trim();
		return EMAIL_REGEX.test(decoded) ? [decoded] : [];
	});
};

const getAllSmartLinks = (content: ADFEntity): Set<string> => {
	const links = new Set<string>();

	const handleCard = (node: ADFEntity) => {
		const url = (node as any).attrs?.url;
		if (url) links.add(url);
	};

	traverse(content, {
		inlineCard: handleCard,
		blockCard: handleCard,
		embedCard: handleCard,
	});

	return links;
};

export const getAllLinks = (content: ADFEntity): Set<string> => {
	const links = getAllSmartLinks(content);

	traverse(content, {
		text: (node) => {
			const linkMark = (node.marks ?? []).find((mark) => mark.type === 'link');
			if (linkMark?.attrs?.href) {
				links.add(linkMark.attrs.href as string);
			}
		},
	});

	return links;
};
